<template>
    <div class="row">
        <div class="col-12 px-0">
            <ul class="qf-dashboard-navigation">
                <li class="qf-active-nav">
                    <a href="#!" @click.prevent>
                        {{$ml.get('Search')}}
                    </a>
                </li>
                <li v-if="loaders.results">
                    <a @clisk.prevent>
                        <font-awesome-icon icon="spinner" class="fa-spin"/>
                    </a>
                </li>
                <li></li>
            </ul>
        </div>
        <div class="col-12">
            <form @submit.prevent="submitForm">
                <div class="row">
                    <div class="col-12 pt-3">
                        <div class="row mb-2">
                            <div class="col-12 col-md-6">
                                <div class="row">
                                    <div class="col-12">
                                        <h6 class="text-uppercase">
                                            {{$ml.get('Legal_Information')}}
                                        </h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="title">{{$ml.get('Title')}}</label>
                                            <input type="text" class="form-control" name="title" id="title"
                                                   v-model="formData.title"
                                                   :placeholder="$ml.get('Title')">
                                            <!--<small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>-->
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="owner">{{$ml.get('Owner')}}</label>
                                            <input type="text" class="form-control" name="owner" id="owner"
                                                   v-model="formData.owner"
                                                   :placeholder="$ml.get('Owner')">
                                            <!--<small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>-->
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="representative">{{$ml.get('Representative')}}</label>
                                            <input type="text" class="form-control" name="representative"
                                                   id="representative"
                                                   :placeholder="$ml.get('Representative')"
                                                   v-model="formData.representative">
                                            <!--<small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="row">
                                    <div class="col-12">
                                        <h6 class="text-uppercase">
                                            {{$ml.get('Search_By_Class')}}
                                        </h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="vienna_class">{{$ml.get('Vienna_Class')}}</label>
                                            <input type="text"
                                                   class="form-control"
                                                   name="vienna_class"
                                                   id="vienna_class"
                                                   :placeholder="$ml.get('Vienna_Class')"
                                                   v-model="viennaClass"
                                                   @input="changeViennaClasses($event)"
                                                   @keydown.tab.prevent="addToViennaClasses"
                                                   @keydown.enter.prevent="addToViennaClasses">
                                            <div class="qf-big">
                                                <template v-for="(viennaClass, index) in formData.viennaClasses">
                                                    <a href="#!" class="badge badge-secondary mr-1"
                                                       @click.prevent="removeViennaClass(index)"
                                                       :key="`viennaClass${index}`">{{viennaClass}}</a>
                                                    <input :key="`viennaClassHidden${index}`" type="hidden"
                                                           name="viennaClasses[]" :value="viennaClass">
                                                </template>
                                            </div>
                                            <small class="form-text">Input the desired classes and separate them by
                                                <strong>';'</strong>, <strong>','</strong> or <strong>space</strong>.
                                                Or you can just press <strong>enter</strong> or <strong>tab</strong>.
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="nice_class">{{$ml.get('Nice_Class')}}&nbsp;&nbsp;&nbsp;&nbsp;<font-awesome-icon
                                                    icon="spinner"
                                                    class="fa-spin"
                                                    v-if="loaders.niceClasses"/>
                                            </label>
                                            <input type="text"
                                                   class="form-control"
                                                   name="nice_class"
                                                   id="nice_class"
                                                   :placeholder="$ml.get('Nice_Class')"
                                                   v-model="niceClass"
                                                   @input="changeNiceClasses($event)"
                                                   @keydown.tab.prevent="addToNiceClasses"
                                                   @keydown.enter.prevent="addToNiceClasses">
                                            <small class="form-text text-warning" v-if="errorsArray.niceClasses">No such
                                                class
                                            </small>
                                            <div class="qf-big">
                                                <template v-for="(niceClass, index) in formData.niceClasses">
                                                    <a href="#!" class="badge badge-secondary mr-1"
                                                       @click.prevent="removeNiceClass(index)"
                                                       v-b-tooltip.hover
                                                       :title="niceClasses[niceClass]"
                                                       :key="`niceClass${index}`">{{niceClass}}</a>
                                                    <input :key="`niceClassHidden${index}`" type="hidden"
                                                           name="niceClasses[]" :value="niceClass">
                                                </template>
                                            </div>
                                            <small class="form-text">Input the desired classes and separate them by
                                                <strong>';'</strong>, <strong>','</strong> or <strong>space</strong>.
                                                Or you can just press <strong>enter</strong> or <strong>tab</strong>.
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
<!--                        <div class="row" v-if="owners.length || types.length">-->
<!--                            <div class="col-12">-->
<!--                                <h6 class="text-uppercase">-->
<!--                                    {{$ml.get('Filters')}}-->
<!--                                </h6>-->
<!--                            </div>-->
<!--                            <div class="col-12 col-md-6" v-if="typeof owners === 'object'">-->
<!--                                <div class="form-group">-->
<!--                                    <label for="ownerFilter">{{$ml.get('Filter_By_Owner')}}</label>-->
<!--                                    <select class="form-control"-->
<!--                                            id="ownerFilter"-->
<!--                                            name="owner_filter"-->
<!--                                            v-model="formData.filterByOwner">-->
<!--                                        <option value="">{{$ml.get('All_owners')}}</option>-->
<!--                                        <option v-for="(owner, ownerIndex) in owners"-->
<!--                                                :value="owner"-->
<!--                                                :key="ownerIndex">-->
<!--                                            {{owner}}-->
<!--                                        </option>-->
<!--                                    </select>-->

<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="col-12 col-md-6" v-if="types.length">-->
<!--                                <div class="form-group">-->
<!--                                    <label for="typeFilter">{{$ml.get('Filter_By_Type')}}</label>-->
<!--                                    <select class="form-control"-->
<!--                                            id="typeFilter"-->
<!--                                            name="type_filter"-->
<!--                                            v-model="formData.filterByType">-->
<!--                                        <option value="">{{$ml.get('All_types')}}</option>-->
<!--                                        <option v-for="(type, typeIndex) in types"-->
<!--                                                :value="type"-->
<!--                                                :key="typeIndex">-->
<!--                                            {{type}}-->
<!--                                        </option>-->
<!--                                    </select>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                    <div class="col-12 pt-3 text-center">
                        <button type="submit" class="btn btn-warning px-4">{{$ml.get('Search')}}</button>
                    </div>
                </div>
            </form>
            <search-results :results="results"
                            :tableFilter="tableFilter"
                            :loadingResults="loaders.results"
                            @changeSort="changeSort">
                <div class="col-12 p-3" v-if="count > tableFilter.limit">
                    <paginator :count="count" :limit="tableFilter.limit" :offset="tableFilter.offset"
                               @changePage="changePage"></paginator>
                </div>
            </search-results>
        </div>
    </div>
</template>

<script>
    import SearchResults from './SearchResults'
    import Paginator from '../../common/Paginator'

    export default {
        name: "SearchInDatabase",
        components: {
            SearchResults, Paginator
        },
        data() {
            return {
                owners: [],
                types: [],
                niceClasses: [],
                viennaClasses: [],
                viennaClass: '',
                niceClass: '',
                formData: {
                    title: '',
                    owner: '',
                    representative: '',
                    viennaClasses: [],
                    niceClasses: [],
                    sortBy: 'title.asc',
                    offset: 0,
                    limit: 30,
                    filterByOwner: '',
                    filterByType: ''
                },
                loaders: {
                    niceClasses: true,
                    results: false
                },
                errorsArray: {
                    niceClasses: false
                },
                results: [],
                count: 0,
                tableFilter: {
                    limit: 30,
                    offset: 0,
                    sort: {
                        field: 'title',
                        direction: 'asc'
                    },
                },
            }
        },
        mounted() {
            this.$store.dispatch('niceClasses').then(response => {
                this.niceClasses = response;
                this.loaders.niceClasses = false;
            }).catch(() => {
                this.loaders.niceClasses = false;
            });
        },
        methods: {
            changeSort(field) {
                if (!this.loaders.results) {
                    if (this.tableFilter.sort.field === field) {
                        this.tableFilter.sort.direction = (this.tableFilter.sort.direction === 'asc') ? 'desc' : 'asc'
                    } else {
                        this.tableFilter.sort = {
                            field: field,
                            direction: 'asc'
                        }
                    }
                    this.submitForm();
                }
            },
            changePage(page) {
                if (!this.loaders.results) {
                    this.tableFilter.offset = (page - 1) * this.tableFilter.limit;
                    this.submitForm();
                }
            },
            changeViennaClasses(event) {
                let symbolsArray = [';', ' ', ','];
                if (symbolsArray.includes(event.target.value[event.target.value.length - 1])) {
                    this.addToViennaClasses();
                }
            },
            addToViennaClasses() {
                let classString = this.viennaClass;
                classString = classString.split(' ')[0];
                classString = classString.split(',')[0];
                classString = classString.split(';')[0];
                if (classString.length) {
                    this.formData.viennaClasses.push(classString);
                }
                this.viennaClass = '';
            },
            removeViennaClass(index) {
                this.formData.viennaClasses.splice(index, 1);
            },
            changeNiceClasses(event) {
                this.errorsArray.niceClasses = false;
                let symbolsArray = [';', ' ', ','];
                if (symbolsArray.includes(event.target.value[event.target.value.length - 1])) {
                    this.addToViennaClasses();
                }
            },
            addToNiceClasses() {
                this.errorsArray.niceClasses = false;
                let classString = this.niceClass;
                classString = classString.split(' ')[0];
                classString = classString.split(',')[0];
                classString = classString.split(';')[0];
                if (classString.length && this.niceClasses[classString] !== undefined) {
                    this.formData.niceClasses.push(classString);
                    this.niceClass = '';
                } else {
                    this.errorsArray.niceClasses = true;
                }
            },
            removeNiceClass(index) {
                this.formData.niceClasses.splice(index, 1);
            },
            submitForm() {
                if (!this.loaders.results) {
                    this.loaders.results = true;
                    this.formData.sortBy = `${this.tableFilter.sort.field}.${this.tableFilter.sort.direction}`;
                    this.formData.offset = this.tableFilter.offset;
                    this.formData.limit = this.tableFilter.limit;
                    this.$store.dispatch('search', this.formData).then(response => {
                        this.results = response.trademarks;
                        this.owners = response.owners;
                        this.types = response.types;
                        this.count = parseInt(response.count);
                        this.loaders.results = false;
                    }).catch(() => {
                        this.loaders.results = false;
                    });
                }
            }
        }
    }
</script>

<style scoped>
</style>
